import { createReducer } from '@reduxjs/toolkit';
import {
	API_ASSIGN_ROUND,
	API_ASSIGN_ROUND_FAIL,
	API_ASSIGN_ROUND_SUCCESS,
	API_END_ROUND,
	API_END_ROUND_FAIL,
	API_END_ROUND_SUCCESS,
	API_GET_BY_DATE_ROUND,
	API_GET_BY_DATE_ROUND_FAIL,
	API_GET_BY_DATE_ROUND_SUCCESS,
	API_GET_CURRENT_ROUND,
	API_GET_CURRENT_ROUND_FAIL,
	API_GET_CURRENT_ROUND_SUCCESS,
	API_PATCH_APPOINTMENT,
	API_PATCH_APPOINTMENT_FAIL,
	API_PATCH_APPOINTMENT_SUCCESS,
	API_UNASSIGN_ROUND,
	API_UNASSIGN_ROUND_FAIL,
	API_UNASSIGN_ROUND_SUCCESS,
	API_GET_SYNC_ROUNDS,
	API_GET_SYNC_ROUNDS_FAIL,
	API_GET_SYNC_ROUNDS_SUCCESS
} from 'actions/round';
import { ErrorAction, errorHandler } from 'utils/error';
import { toast } from 'react-toastify';

const initialState = {
	list: {
		data: [],
		loading: false
	},
	current: {
		data: {},
		loading: false
	}
};

const round = createReducer(initialState, {
	/** GET BY DATE **/
	[API_GET_BY_DATE_ROUND]: (state, action) => {
		state.list.loading = true;
	},
	[API_GET_BY_DATE_ROUND_FAIL]: (state, action) => {
		errorHandler('Tournée', ErrorAction.READ, action.error);
		state.list.loading = false;
	},
	[API_GET_BY_DATE_ROUND_SUCCESS]: (state, action) => {
		state.list.loading = false;
		state.list.data = action.payload.data;
	},

	/** GET CURRENT **/
	[API_GET_CURRENT_ROUND]: (state, action) => {
		state.current.loading = true;
	},
	[API_GET_CURRENT_ROUND_FAIL]: (state, action) => {
		errorHandler('Tournée', ErrorAction.READ, action.error);
		state.current.loading = false;
	},
	[API_GET_CURRENT_ROUND_SUCCESS]: (state, action) => {
		state.current.loading = false;
		state.current.data = action.payload.data;
	},

	/** ASSIGN ROUND **/
	[API_ASSIGN_ROUND]: (state, action) => {
		state.current.loading = true;
	},
	[API_ASSIGN_ROUND_FAIL]: (state, action) => {
		errorHandler('Affectation tournée', ErrorAction.UPDATE, action.error);
		state.current.loading = false;
	},
	[API_ASSIGN_ROUND_SUCCESS]: (state, action) => {
		state.current.loading = false;
		state.current.data = action.payload.data;
	},

	/** UNASSIGN ROUND **/
	[API_UNASSIGN_ROUND]: (state, action) => {
		state.current.loading = true;
	},
	[API_UNASSIGN_ROUND_FAIL]: (state, action) => {
		errorHandler('Desaffectation tournée', ErrorAction.UPDATE, action.error);
		state.current.loading = false;
	},
	[API_UNASSIGN_ROUND_SUCCESS]: (state, action) => {
		state.current.loading = false;
		state.current.data = {};
	},

	/** PATCH APPOINTMENT **/
	[API_PATCH_APPOINTMENT]: (state, action) => {
		state.loading = true;
	},
	[API_PATCH_APPOINTMENT_FAIL]: (state, action) => {
		errorHandler('Tournée', ErrorAction.UPDATE, action.error);
		state.loading = false;
	},
	[API_PATCH_APPOINTMENT_SUCCESS]: (state, action) => {
		state.loading = false;
		state.data.appointments[
			state.data.appointments.findIndex(i => i.id === action.payload.data.id)
		] = action.payload.data;

	},

	/** UNASSIGN ROUND **/
	[API_END_ROUND]: (state, action) => {
		state.current.loading = true;
	},
	[API_END_ROUND_FAIL]: (state, action) => {
		errorHandler('Validation tournée', ErrorAction.UPDATE, action.error);
		state.current.loading = false;
	},
	[API_END_ROUND_SUCCESS]: (state, action) => {
		toast.success('Tournée terminée');

		state.current.loading = false;
		state.current.data = {};

		state.list.data[
			state.list.data.findIndex(r => r.id === action.payload.data.id)
		].status = 'DONE';
	},

	/** GET APPOINTMENTS BY NURSE **/
	[API_GET_SYNC_ROUNDS]: (state, action) => {
		state.list.loading = true;
	},
	[API_GET_SYNC_ROUNDS_FAIL]: (state, action) => {
		errorHandler('Synchronisation tournée', ErrorAction.UPDATE, action.error);
		state.list.loading = false;
	},
	[API_GET_SYNC_ROUNDS_SUCCESS]: (state, action) => {
		toast.success('Synchronisation réussie');
		state.list.loading = false;
	}
});

export default round;
